import {GitBranchIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasBaseForce, pluralize} from './activity-row-helpers'

export function buildBaseForceLabel(baseCount: number, forceCount: number): string {
  const parts: string[] = []
  if (baseCount > 0) parts.push(`${baseCount} base ${pluralize(baseCount, 'change', 'changes')}`)
  if (forceCount > 0) parts.push(`${forceCount} force ${pluralize(forceCount, 'push', 'pushes')}`)
  return parts.join(', ')
}

export function BaseForceRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasBaseForce(summary)) return null

  const baseCount = summary?.baseChanged?.count ?? 0
  const forceCount = summary?.forcePushed?.count ?? 0
  const label = buildBaseForceLabel(baseCount, forceCount)
  const expectedCount = baseCount + forceCount

  return (
    <SidebarActivityRow
      icon={GitBranchIcon}
      categoryLabel="Base changes and force pushes"
      label={label}
      group="baseForce"
      expectedCount={expectedCount}
    />
  )
}
